import { createFileRoute } from '@tanstack/react-router';
import { loadShire, makeShireSubPageHead, type ShireLoaderData } from '../components/shared/shire-sub-route';
import { ShireSubPageShell } from '../components/shared/ShireSubPageShell';
import { SeniorsServices } from '../components/shared/SeniorsServices';

export const Route = createFileRoute('/shire/$name_/seniors')({
  loader: ({ params }) => loadShire(params.name),
  head: (ctx) =>
    makeShireSubPageHead(
      (ctx as { loaderData?: ShireLoaderData } | undefined)?.loaderData,
      'Seniors',
      'Seniors services, aged care providers and My Aged Care entry points for this shire.',
    ),
  component: SeniorsPage,
});

function SeniorsPage() {
  const { shire } = Route.useLoaderData() as ShireLoaderData;
  return (
    <ShireSubPageShell
      shire={shire}
      eyebrow="Seniors"
      title="Seniors & aged care"
      lede={`Local aged-care providers and seniors programs in the Shire of ${shire.name}. For My Aged Care, WA Seniors Card and Centrelink, see the electorate-wide seniors guide.`}
    >
      <SeniorsServices shireId={shire.id} />
    </ShireSubPageShell>
  );
}
